import { useRef } from "react";

function CollapseSection({ open, children }) {
  const ref = useRef(null);

  return (
    <div
      className="smooth-collapse"
      style={{ height: open ? ref.current?.scrollHeight : 0 }}
    >
      <div ref={ref}>
        {children}
      </div>
    </div>
  );
}

export default CollapseSection